import React from 'react';

const PlayIcon = props => (
  <svg width="52" height="52" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none">
      <circle stroke="#ffffff" strokeWidth="2" cx="26" cy="26" r="25" />
      <path fill="#ffffff" d="M19 20.894L23.929 16 38 24.66 19 37z" />
    </g>
  </svg>
);

export default PlayIcon;
